import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { INotesDetails, ISectionData, SectionIds } from '@modeso/aumico-lib-annualreport-fe';
import { EMPTY_ARRAY_LENGTH } from '@modeso/aumico-lib-core-fe';
import { IStyleOptions } from '@modeso/types__aumico-lib-annualreport-be';
import Debug from 'debug';
import { ITableOfContentEntry } from '../../../interfaces/table-of-content-entry.interface';
import { TocService } from '../services/toc.service';

const debug = Debug('aumico:project-reports-fe:AnnualReportAOPPage');
@Component({
    selector: 'aumico-annual-report-toc-page',
    template: `
        <aumico-annual-report-toc-display
            [stylePreferenceOptions]="styleOptions"
            [contentItems]="contentItems"
            [activeLocale]="activeLocale"
        >
        </aumico-annual-report-toc-display>
    `,
})
export class AnnualReportTocPage implements OnChanges {
    public contentItems: ITableOfContentEntry[] = [];

    @Input() styleOptions: IStyleOptions | undefined;

    @Input() orderedSectionsTitles: string[] = [];

    @Input() notesDetails: INotesDetails[] = [];

    @Input() orderedSectionsIds: SectionIds[] = [];

    @Input() activeLocale: string;

    @Input() complementaryReports: ISectionData[] = [];
    @Input() complementaryReportsAsAppendix: ISectionData[] = [];

    @Input() appendixSectionTitle: string;

    constructor(private tocService: TocService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (
            this.orderedSectionsTitles.length !== EMPTY_ARRAY_LENGTH &&
            this.orderedSectionsIds.length !== EMPTY_ARRAY_LENGTH
        ) {
            this.contentItems = this.tocService.getTableOfContentEntries(
                this.orderedSectionsTitles,
                this.orderedSectionsIds,
                this.complementaryReportsAsAppendix,
                this.complementaryReports,
                this.notesDetails,
            );
        }
    }
}
